<template>
  <div class="partnerships">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true" color="#fff">
        <use xlink:href="#icon-lianmengyingxiao"></use>
      </svg>
    </breadcrumbs>
    <div class="partnerships-content">
      <div class="table-head">
        <a-space>
          <buttonGroups
            :pagination="{
              total: pagination.total,
              page: pagination.current,
              size: pagination.size,
            }"
            :tableData="dataSource"
            @pageChange="onPageChange"
          />
        </a-space>
        <a-space>
          <!-- <a-input-search
            v-model:value="keywords"
            :placeholder="$t('seller.common.searchPlaceholder')"
            allow-clear
            @search="onSearch"
            @enter="onSearch"
          >
          </a-input-search> -->
        </a-space>
      </div>
      <div class="filters">
        <div class="filter-item">
          <div class="title">{{ $t('seller.common.brand') }}</div>
          <div class="filter-content">
            <BrandSelect v-model="formState.brandId" />
          </div>
        </div>
        <div class="filter-item">
          <div class="title">{{ $t('seller.common.publisher') }}</div>
          <div class="filter-content">
            <PublisherSelect v-model="formState.publisherId" />
          </div>
        </div>
        <div class="filter-item">
          <div class="title">{{ $t('seller.brandsPage.collaborationPeriod') }}</div>
          <div class="filter-content">
            <artemisads-range-picker
              @change="handleChangeDate"
              :allowClear="true"
              v-model:value="dateParams"
              format="YYYY-MM-DD"
            />
          </div>
        </div>
        <div class="filter-item">
          <div class="title">{{ $t('seller.partnershipsPage.filterAccAuthStatus') }}</div>
          <div class="filter-content">
            <artemisads-segmented
              class="segmented"
              v-model:value="formState.associateBrandProgress"
              :options="accAuthorizationSegmentOptions"
            />
          </div>
        </div>
      </div>
      <div class="table">
        <artmisads-table
          :columns="columns"
          :dataSource="dataSource"
          :pagination="pagination"
          :loading="loading"
          :change="onChangePage"
          :scroll="{ x: 2000 }"
        >
           <template #headerCell="{ column }">
            <template v-if="column.dataIndex === 'accAuthorization'">
              <span>
                {{ $t('seller.brandsPage.accAuthColumn') }}
                <a-popover placement="bottom" trigger="hover">
                  <template #content>
                    <div class="popover-content">
                      <div class="popover-title">
                        {{
                          $t('seller.brandsPage.accPopoverTitle', {
                            host: CURRENCY_MAPPER[user?.userInfo?.countryCode]?.host,
                          })
                        }}
                      </div>
                      <div class="popover-content-text">
                        <p>{{ $t('seller.brandsPage.accPopoverIntro') }}</p>
                      </div>
                      <div class="popover-bottom-text">
                        <div class="popover-bottom-text-top">
                          <Status
                            type="delivering"
                            :noBorder="true"
                            style="margin-left: -5px"
                          />
                          {{ $t('seller.brandsPage.accPopoverCaseGeTitle') }}
                        </div>
                        <div class="popover-bottom-text-bottom">
                          <p>{{ $t('seller.brandsPage.accPopoverCaseGeLine1') }}</p>
                          <p>{{ $t('seller.brandsPage.accPopoverCaseGeLine2') }}</p>
                        </div>
                      </div>
                      <div class="popover-bottom-text-content">
                        <div class="popover-bottom-text-top">
                          <Status
                            type="delivering"
                            :noBorder="true"
                            style="margin-left: -5px"
                          />
                          {{ $t('seller.brandsPage.accPopoverCaseLtTitle') }}
                        </div>
                        <div class="popover-bottom-text-bottom">
                          <p>{{ $t('seller.brandsPage.accPopoverCaseLtLine1') }}</p>
                        </div>
                      </div>
                    </div>
                  </template>
                  <Icon name="wenhao-tianchong" class="wenhao" />
                </a-popover>
              </span>
            </template>
            <template v-else>{{ column.title }}</template>
          </template>
          <template #bodyCell="{ column, text, record }">
            <template v-if="column.key === 'brand'">
              <a
                class="brand-title"
                target="_blank"
                @click="goBrandDetail(record)"
              >
                <LogoImage
                  :maxWidth="'95%'"
                  :logoUrl="record.associateBrandVO.logoImageUrl"
                  :brandName="record.associateBrandVO.amazonBrandName"
                  :width="56"
                  :height="56"
                  :fontSize="10"
                  :borderRadius="4"
                />
                <div class="brand-name">
                  {{ record.associateBrandVO.amazonBrandName }}
                </div>
              </a>
            </template>
            <template v-if="column.key === 'publisher'">
              <div class="publisher-box">
              <a class="brand-title" @click="goPublisherDetail(record)">
                <LogoImage
                  :maxWidth="'95%'"
                  :logoUrl="record.publisherVO.publicImage"
                  :brandName="record.publisherVO.creatorName"
                  :width="28"
                  :height="28"
                  :fontSize="8"
                  :borderRadius="4"
                />
                <div class="brand-name">
                  {{ record.publisherVO.creatorName }}
                </div>
              </a>
              </div>
              
            </template>
            <template v-if="column.key === 'amazonSellerName'">
              <div>{{ record.associateBrandVO.amazonName }}</div>
            </template>
            <template v-if="column.key === 'activeProducts'">
              <a class="table-font" @click="goProductPage(record, 'active')">
                {{ record.associateBrandVO.associateActiveProductCount }}
              </a>
            </template>
            <template v-if="column.key === 'inactiveProducts'">
              <a class="table-font" @click="goProductPage(record, 'inactive')">
                {{ record.associateBrandVO.associateInactiveProductCount }}
              </a>
            </template>
            <template v-if="column.key === 'commission'">
              <div>{{ returnAttributionCommission(record) }}</div>
              <div class="time" v-if="record.timeMonthCommission">
                <a-popover placement="bottom">
                  <template #content>
                    <div class="contentBox">
                      <p class="popoverContent">
                        {{
                          $t('seller.productTable.commissionChangePopover', {
                            rate: returnAttributionCommissionBottom(record),
                            date: record.timeMonthCommission,
                          })
                        }}
                      </p>
                      <div
                        class="cancelBtn"
                        @click="
                          cancelBrand(record, 'commissionChangeOperations')
                        "
                      >
                        {{ $t('seller.common.cancel') }}
                      </div>
                    </div>
                  </template>
                  <template #title>
                    <span></span>
                  </template>
                  <div class="time-mid">
                    <Icon name="Frame" />
                    <span class="time-month">{{
                      $t('seller.productTable.commissionFromMonth', {
                        rate: returnAttributionCommissionBottom(record),
                        month: record.timeMonthCommission,
                      })
                    }}</span>
                    <Icon name="a-error-tianchong5" class="close-icon" />
                  </div>
                </a-popover>
              </div>
            </template>
            <template v-if="column.key === 'collaborationPeriod'">
              <div class="time-box" style="margin-bottom: 10px;">
                <span class="timeTitle">{{ $t('seller.partnershipsPage.collaborationStart') }}</span>
                <span class="timeContent">{{ returnStartTime(record) }}</span>
              </div>
              <div class="time-box">
                <span class="timeTitle">{{ $t('seller.partnershipsPage.collaborationEnd') }}</span>
                <span class="timeContent">{{ returnEndTime(record) }}</span>
              </div>
            </template>
            <template v-if="column.key === 'accAuthorization'">
              <div
                class="ccAuthorizationStatus"
                v-if="record?.associateBrandVO?.ccAuthorizationStatus"
              >
                <Status
                  :type="
                    record?.associateBrandVO?.ccAuthorizationStatus.toLowerCase()
                  "
                  :noBorder="true"
                  :text="
                    capitalize(
                      record?.associateBrandVO?.ccAuthorizationStatus.toLowerCase(),
                    )
                  "
                />
              </div>
            </template>
            <template v-if="column.key === 'actions'">
              <div class="actions">
                <!-- <div style="margin-bottom: 10px">
                  <artmisads-button
                    type="default"
                    :isSquare="true"
                    size="small"
                    @click="openEdit(record)"
                  >
                    Edit
                  </artmisads-button>
                </div> -->
                <div style="margin-bottom: 10px">
                  <artmisads-button
                    type="default"
                    :isSquare="true"
                    size="small"
                    @click="handleHistory(record)"
                  >
                    {{ $t('seller.partnershipsPage.viewPartnershipHistory') }}
                  </artmisads-button>
                </div>
                <div>
                  <artmisads-button
                    type="default"
                    :isSquare="true"
                    size="small"
                    @click="goPage(record)"
                  >
                    {{ $t('seller.partnershipsPage.addCommissionRule') }}
                  </artmisads-button>
                </div>
              </div>
            </template>
          </template>
        </artmisads-table>
      </div>
    </div>
    <editModal ref="editModalRef" @updateData="getData" />
    <history-model ref="historyModelRef" />
  </div>
</template>
<script setup>
import { ref, reactive, onMounted, onUnmounted, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import moment from 'moment'
import breadcrumbs from '../../breadcrumbs.vue'
import buttonGroups from '~/components/buttonGroups.vue'
import { publishersApi, brandApi } from '@/server'
import { CURRENCY_MAPPER } from '@/contants/common'
import { useUserInfoStore } from '@/storeData'
import { message } from 'ant-design-vue'
import LogoImage from '@/components/LogoImage.vue'
import { useRouter } from 'vue-router'
import { useSellerProductStore } from '@/storeData/sellerproduct'
import editModal from './components/editModal.vue'
import PublisherSelect from '@/components/PublisherSelect.vue'
import BrandSelect from '@/components/BrandSelect.vue'
import Status from '@/components/Status.vue'
import { capitalize } from '~/utils'
import { COUNTRY_TIME_TZ } from '~/contants/common.js'
import Icon from '@/components/Icon.vue'
import HistoryModel from '~/components/historyModel.vue'

const { t, locale } = useI18n()
const user = useUserInfoStore()
const editModalRef = ref(null)
const historyModelRef = ref(null)

const productStore = useSellerProductStore()
const brandRouter = useRouter()
const timezone = COUNTRY_TIME_TZ[user.userInfo.countryCode]
const formState = ref({
  brandId: '',
  publisherId: '',
  startTime: '',
  endTime: '',
  associateBrandProgress: 'All',
})
const breadcrumbsData = computed(() => ({
  title: t('seller.menu.partnerships'),
  hasTitleIcon: true,
  color: 'rgba(80, 137, 250, 1)',
  links: [
    {
      name: t('seller.common.home'),
      path: '/seller/dashboard',
    },
    {
      name: t('seller.brandsPage.breadcrumbAssociateCentral'),
      path: '/seller/associateCentral/publishers',
    },
    {
      name: t('seller.menu.partnerships'),
      path: '/seller/associateCentral/partnerships',
    },
  ],
}))

const accAuthorizationSegmentOptions = computed(() => [
  { label: t('seller.common.all'), value: 'All' },
  { label: t('seller.partnershipsPage.accSegmentAuthorized'), value: 'Authorized' },
  {
    label: t('seller.partnershipsPage.accSegmentNotAuthorized'),
    value: 'Not Authorized',
  },
])
const pagination = reactive({
  total: 0,
  defaultPageSize: 10,
  size: 10,
  current: 1,
  showSizeChanger: true,
  pageSize: 10,
  pageSizeOptions: ['10', '20', '30', '40', '50'],
})
const dateParams = ref([])
const columns = computed(() => {
  locale.value
  return [
    {
      title: t('seller.brand.colBrand'),
      dataIndex: 'brand',
      key: 'brand',
      width: 220,
    },
    {
      title: t('seller.brand.colAmazonSellerName'),
      dataIndex: 'amazonSellerName',
      key: 'amazonSellerName',
      width: 220,
    },
    {
      title: t('seller.brand.colActiveProducts'),
      dataIndex: 'activeProducts',
      key: 'activeProducts',
      width: 220,
    },
    {
      title: t('seller.brand.colInactiveProducts'),
      dataIndex: 'inactiveProducts',
      key: 'inactiveProducts',
      width: 220,
    },
    {
      title: t('seller.brandsPage.colCommission'),
      dataIndex: 'commission',
      key: 'commission',
      width: 220,
    },
    {
      title: t('seller.menu.publisher'),
      dataIndex: 'publisher',
      key: 'publisher',
      width: 200,
    },
    {
      title: t('seller.brandsPage.collaborationPeriod'),
      dataIndex: 'collaborationPeriod',
      key: 'collaborationPeriod',
      width: 220,
    },
    {
      title: t('seller.brandsPage.accAuthColumn'),
      dataIndex: 'accAuthorization',
      key: 'accAuthorization',
    },
    {
      title: t('seller.brand.colAction'),
      dataIndex: 'actions',
      key: 'actions',
      fixed: 'right',
      width: 250,
    },
  ]
})
const handleChangeDate = (val) => {
  if (Array.isArray(val) && val.length == 2) {
    formState.value.startTime = moment(val[0]).valueOf()
    formState.value.endTime = moment(val[1]).valueOf()
  } else {
    formState.value.startTime = ''
    formState.value.endTime = ''
  }
}
const goBrandDetail = (item) => {
  const brandVO = item?.associateBrandVO
  window.open(`/seller/brand/detail/${brandVO.id}`, '_blank')
}
const goPublisherDetail = (item) => {
  const publisherVO = item?.publisherVO
  const data = {
    id: publisherVO.id,
    creatorName: publisherVO.creatorName,
    publicImage: publisherVO.publicImage,
    promotionCountries: publisherVO.promotionCountries,
    promotionMethods: publisherVO.promotionMethods,
    promotionProductCategories: publisherVO.promotionProductCategories,
    publicBio: publisherVO.publicBio,
    associateBrandCount: publisherVO.associateBrandCount,
    associateEnabled: publisherVO.associateEnabled,
    links: publisherVO.links,
  }
  sessionStorage.setItem('publisherDetail', JSON.stringify(data))
  window.open(`/seller/publishers/${publisherVO.id}`, '_blank')
}
// const handleChange=(val)=>{
//   formState.value.associateBrandProgress=val
// }
const goProductPage = (item, type) => {
  let params = {
    brandName: item.associateBrandVO.amazonBrandName,
    brandId: item.associateBrandVO.id,
    activeTabInfo: 1,
  }
  if (type == 'active') {
    params.status = 'active'
  } else {
    params.status = 'inactive'
  }
  productStore.setParams(params)
  brandRouter.push({
    name: 'product',
    query: params,
  })
}
const goPage = (item) => {
  brandRouter.push({
    path: '/seller/commission-rule',
    query: {
      brandId: item.associateBrandVO.id,
      publisherId: item.publisherVO.id,
      creatorName: item.publisherVO.creatorName,
      // collaborationPeriod: item.associateBrandVO.collaborationPeriod,
    },
  })
}
const openEdit = (item) => {
  editModalRef.value.initData(item)
  // formState.value={
  //   brandId:item.associateBrandVO.id,
  //   publisherId:item.associateBrandVO.publisherId,
  //   collaborationPeriod:item.associateBrandVO.collaborationPeriod
  // }
}
const returnAttributionCommissionBottom = (record) => {
  if (!record?.pendingOperations?.length) return ''
  try {
    const parsed = JSON.parse(record.pendingOperations[0].changeTo)
    const rate = parsed.commissionRate ?? parsed.commission_rate
    if (rate != null && rate !== '') {
      return `${rate}%`
    }
  } catch (e) {
    // ignore invalid changeTo
  }
  return ''
}
const returnAttributionCommission = (record) => {
  let str = ''
  if (record?.currentCommissionDetail) {
    if (Object.keys(record?.currentCommissionDetail).length) {
      str = record?.currentCommissionDetail?.commissionRate + '%'
    }
  } else {
    str = '--'
  }
  return str
}
// setTimeout(() => {
//  editModalRef.value.initData({})
// }, 0)
const loading = ref(true)
let keywords = ref('')
const dataSource = ref([])
const handleHistory = (record) => {
  // if (props.brandId) {
  //   param = {
  //     ...record,
  //     brandId: props.brandId,
  //   }
  // } else {
  //   param = {
  //     ...record,
  //   }
  // }
  const param = {
    publisherId: record.publisherVO.id,
    brandId: record.associateBrandVO.id,
  }
  historyModelRef.value?.showModal(param, 'publishers')
}
watch(
  () => formState.value,
  async (newVal, oldVal) => {
    if (newVal) {
      pagination.current = 1
      getData()
    }
  },
  { deep: true },
)
const returnStartTime = (item) => {
  return moment(item?.associatePublisherBrandCommissionVO?.startDate)
    .tz(timezone)
    .format('YYYY-MM-DD')
}
const returnEndTime = (item) => {
  return moment(item?.associatePublisherBrandCommissionVO?.endDate)
    .tz(timezone)
    .format('YYYY-MM-DD')
}
// const returnTime = (item) => {
//   return `${moment(item?.associatePublisherBrandCommissionVO?.startDate)
//     .tz(timezone)
//     .format('YYYY-MM-DD')}~${moment(
//     item?.associatePublisherBrandCommissionVO?.endDate,
//   )
//     .tz(timezone)
//     .format('YYYY-MM-DD')}`
// }
const onPageChange = (page) => {
  pagination.current = page
  getData()
}
const onSearch = () => {
  getData()
}
const getData = async () => {
  loading.value = true
  try {
    let data = await publishersApi.getActiveProducts({
      brandId: formState.value.brandId,
      publisherId: formState.value.publisherId,
      startTime: formState.value.startTime,
      endTime: formState.value.endTime,
      page: pagination.current,
      size: pagination.size,
      ccAuthorizationStatus:
        formState.value.associateBrandProgress == 'All'
          ? undefined
          : formState.value.associateBrandProgress == 'Authorized'
          ? 'authorized'
          : 'pending',
    })

    if (data.success) {
      dataSource.value = data.data.data
      dataSource.value.forEach((item) => {
        if (item.pendingOperations?.length) {
          item.timeMonthCommission = moment(
            item.pendingOperations[0].effectiveTime,
          )
            .tz(timezone)
            .format('MM/DD')
          item.timeMonthNameCommission = moment(
            item.pendingOperations[0].effectiveTime,
          )
            .tz(timezone)
            .format('MMM DD,YYYY')
          item.timeMonthNameAllCommission = moment(
            item.pendingOperations[0].effectiveTime,
          )
            .tz(timezone)
            .format('MMMM DD,YYYY')
        }
      })
      pagination.total = data.data.total
    } else {
      message.error(data.error)
    }
  } catch (error) {
    message.error(t('seller.partnershipsPage.msgFetchDataFailed'))
  } finally {
    loading.value = false
  }
}
const onChangePage = (data, filters, sorter) => {
  const { current, pageSize } = data
  pagination.current = current
  pagination.size = pageSize
  pagination.pageSize = pageSize
  getData()
}
const cancelBrand = async (record, type) => {

  const data = await brandApi.cancelTask({
    operationId: record.pendingOperations[0].operationId,
  })
  if (data.success) {
    message.success(t('seller.partnershipsPage.msgCancelSuccess'), 1)
    getData()
  }
}
onUnmounted(() => {
  sessionStorage.removeItem('publiserName')
})
onMounted(() => {
  if (!sessionStorage.getItem('publiserName')) {
    getData()
  }
})
</script>
<style lang="less" scoped>
 .brand-title {
  display: flex;
  align-items: center;
  gap: 8px;
  .brand-name {
    font-family: Sora;
font-weight: 400;
font-style: Regular;
font-size: 14px;
leading-trim: NONE;
line-height: 22px;
letter-spacing: 0%;
    flex: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    color: rgba(15, 6, 41, 1);
  }
}
.time-box{
  display: inline-flex;
  align-self: center;
  justify-content: space-between;
  width: 130px !important;
}
.timeTitle {
font-family: Sora;
font-weight: 400;
font-style: Regular;
font-size: 13px;
leading-trim: NONE;
line-height: 15px;
letter-spacing: 0.3px;
color: rgba(15, 6, 41, 0.5);
}
.timeContent{
 
  font-family: Sora;
font-weight: 500;
font-style: Medium;
font-size: 13px;
leading-trim: NONE;
line-height: 15px;
letter-spacing: 0.3px;
color: rgba(15, 6, 41, 0.9);
}
.cancelBtn {
  cursor: pointer;
  margin-top: 10px;
  max-width: 70px;
  font-family: Sora;
  font-weight: 500;
  font-size: 13px;
  color: rgba(235, 78, 61, 1);
  line-height: 18px;
  letter-spacing: 0.3px;
  padding: 3px 11px;
  text-align: center;
  background-color: rgba(254, 238, 236, 1);
  border: 1px solid rgba(245, 119, 105, 1);
  border-radius: 6px;
}
.close-icon {
  width: 18px;
  height: 18px;
  color: rgba(15, 6, 41, 0.2);
}
.time {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(245, 246, 247, 1);
  border-radius: 6px;
  padding: 4px 8px;
  margin-top: 10px;
  .time-mid {
    display: flex;
    align-items: center;
    gap: 4px;
  }
}
.table-font {
  font-family: Sora, sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: var(--dark-1);
  letter-spacing: 0.4px;
  line-height: 19px;
  cursor: pointer;
  text-decoration: underline;
}
.partnerships {
  padding: 0 16px 16px;
}

.partnerships-content {
  padding: 16px;
  background: #fff;
  border-radius: 8px;

  .table-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .filters {
    height: 86px;
    border-radius: 8px;
    background-color: rgba(248, 247, 252, 1);
    margin: 32px 0;
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 15px;
    .filter-item {
      flex: 1;
      .title {
        font-family: Sora;
        font-weight: 500;
        font-size: 13px;
        margin-bottom: 8px;
      }
      .filter-content {
        width: 100%;
      }
    }
  }
}
.publisher-box{
  background-color: rgba(241, 240, 245, 1);
  padding: 3px 4px;
  border-radius: 6px;
  width: auto;
  display: inline-block;
  max-width: 200px;
  .brand-title {
  display: flex;
  align-items: center;
  gap: 8px;
  .brand-name {
    font-family: Sora;
font-weight: 400;
font-style: Regular;
font-size: 14px;
leading-trim: NONE;
line-height: 22px;
letter-spacing: 0%;
    flex: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    color: rgba(15, 6, 41, 1);
  }
}
}
.wenhao {
  color: rgba(245, 155, 0, 1);
}
.popover-content {
  .popover-title {
    font-family: Sora;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 13px;
    color: rgba(15, 6, 41, 1);
  }
  .popover-content-text {
    margin: 21px 0;
    font-family: Sora;
    font-weight: 400;
    font-style: Regular;
    font-size: 13px;
    color: rgba(15, 6, 41, 1);
  }
  .popover-bottom-text {
    background-color: rgba(248, 247, 252, 1);
    border-radius: 8px;
    padding: 12px 16px;
    height: 88px;
  }
  .popover-bottom-text-bottom {
    p {
      font-family: Sora;
      font-weight: 400;
      font-style: Regular;
      font-size: 13px;
      color: rgba(15, 6, 41, 1);
    }
  }
  .popover-bottom-text-top {
    display: flex;
    align-items: center;
    font-family: Sora;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 13px;
    color: rgba(108, 61, 242, 1);
  }
  .popover-bottom-text-content {
    background-color: rgba(248, 247, 252, 1);
    border-radius: 8px;
    height: 70px;
    padding: 12px 16px;
    margin-top: 21px;
  }
}
</style>
